import { Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import { UNTITLED_ISSUE_TITLE } from "@overmap-ai/common"
import type { Issue, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssueTypeIcon } from "../Icons/IssueTypeIcon"
import { IssueIndexLabel } from "../IndexLabels/IssueIndex"

export interface IssueGroupProps extends MenuGroupProps {
	issues: Stored<Issue>[]
	onSelectIssue: (issue: Stored<Issue>) => void
}

export const IssueGroup = memo<IssueGroupProps>((props) => {
	const { ref, issues, onSelectIssue, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{issues.map((issue) => {
				return (
					<Menu.Item key={issue.uuid} onSelect={() => onSelectIssue(issue)}>
						<IssueTypeIcon issueTypeId={issue.issue_type} inline />
						<IssueIndexLabel issueId={issue.uuid} />
						<Text className="truncate" accentColor="base">
							{issue.title || UNTITLED_ISSUE_TITLE}
						</Text>
					</Menu.Item>
				)
			})}
		</Menu.Group>
	)
})
IssueGroup.displayName = "IssueGroup"
